import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=25a2ad30"
import script from "./Authorization.js?vue&type=script&lang=js&external"
export * from "./Authorization.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports